import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home-heading-wrap" }
const _hoisted_2 = { class: "home-actions" }
const _hoisted_3 = {
  class: "home-socials",
  "aria-label": "Perfis profissionais"
}
const _hoisted_4 = ["href", "aria-label"]

import { RouterLink } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeHeading',
  props: {
    contactIcons: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h1", {
      id: "home-heading",
      class: "home-heading",
      "data-page-focus": ""
    }, [
      _createTextVNode(" IDEIAS"),
      _createElementVNode("br"),
      _createTextVNode("QUE VIRAM"),
      _createElementVNode("br"),
      _createElementVNode("em", null, "SISTEMAS.")
    ], -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "home-intro" }, " Sou Vinicius Spanol, desenvolvedor fullstack. Transformo problemas reais em experiências web e mobile, do frontend ao backend. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(RouterLink), {
        class: "button-primary home-cta",
        to: "/projects"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", null, "Explorar projetos", -1),
          _createElementVNode("span", { "aria-hidden": "true" }, "↗", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_unref(RouterLink), {
        class: "home-about-link",
        to: "/about"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Conhecer o percurso ", -1),
          _createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("nav", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactIcons, (icon) => {
        return (_openBlock(), _createElementBlock("a", {
          key: icon.name,
          class: "social-link",
          href: icon.link,
          "aria-label": icon.name,
          target: "_blank",
          rel: "noopener noreferrer"
        }, [
          _createVNode(_component_v_icon, {
            name: icon.icon,
            scale: "1.1",
            "aria-hidden": "true"
          }, null, 8, ["name"]),
          _createElementVNode("span", null, _toDisplayString(icon.name), 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})